<template>
  <div class="home">
    <div class="topmain">
      <div class="top">
        <div>您好，欢迎访问苏州通信行业协会网站</div>
        <div class="tianqi">
          <iframe width="450" height="25" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=1&icon=1"></iframe>
        </div>
      </div>
      <topnav></topnav>
      <div class="toptext">发挥桥梁纽带作用 促进行业和谐发展</div>
      <div class="banner">
        <el-carousel :interval="5000">
          <el-carousel-item v-for="item in bannerlist" :key="item.id">
            <img :src="item.img" alt="" srcset="" style="height:100%;width: 100%;">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="center">
      <div class="centeritem">
        <img src="~@/assets/image/home/centericon1.png" alt="" srcset="" style="height:78px;width: 100%;">
        <div class="itemtoptext">
          <div>政策法规</div>
          <div>住宅小区通信配套设施建设管理</div>
        </div>
        <div class="textinfo" v-for="item in list1" :key="item.id">
          {{item.title}}
        </div>
        <div class="more" @click="tomore(6.1)">
          VIEW MORE
        </div>
      </div>
      <div class="centeritem">
        <img src="~@/assets/image/home/centericon2.png" alt="" srcset="" style="height:78px;width: 100%;">
        <div class="itemtoptext">
          <div>行业资讯</div>
          <div>住宅小区通信配套设施建设管理</div>
        </div>
        <div class="textinfo" v-for="item in list2" :key="item.id">
          {{item.title}}
        </div>
        <div class="more" @click="tomore(4)">
          VIEW MORE
        </div>
      </div>
      <div class="centeritem">
        <img src="~@/assets/image/home/centericon3.png" alt="" srcset="" style="height:78px;width: 100%;">
        <div class="itemtoptext">
          <div>协会动态</div>
          <div>住宅小区通信配套设施建设管理</div>
        </div>
        <div class="textinfo" v-for="item in list3" :key="item.id">
          {{item.title}}
        </div>
        <div class="more" @click="tomore(3.1)">
          VIEW MORE
        </div>
      </div>
    </div>
    <div class="center center2">
      <div class="centeritem">
        <div class="title">寓意生活
          <span @click="tomore(3.2)">更多</span>
        </div>
        <div class="center2main">
          <div v-for="item in list4" :key="item.id">
            {{item.title}}
          </div>
        </div>
        <img src="~@/assets/image/home/center2icon1.png" alt="">
      </div>
      <div class="centeritem">
        <div class="title">竣工信息
          <span @click="tomore(10)">更多</span>
        </div>
        <div class="center2main">
          <div v-for="item in list5" :key="item.id">
            {{item.title}}
          </div>
        </div>
        <img src="~@/assets/image/home/center2icon2.png" alt="">
      </div>
      <div class="centeritem">
        <div class="title">通知公告
          <span @click="tomore(5.3)">更多</span>
        </div>
        <div class="center2main">
          <div v-for="item in list6" :key="item.id">
            {{item.title}}
          </div>
        </div>
        <img src="~@/assets/image/home/center2icon3.png" alt="">
      </div>
    </div>
    <div class="moreiconlink">
      <div class="bottom1">
        <div class="bottomicon" v-for="item in bottomnav1" :key="item.id" @click="topage(item)">
          <img :src="item.icon" alt="">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="bottom1 bottom2">
        <div class="bottomicon" v-for="item in bottomnav2" :key="item.id" @click="toLink(item.path)">
          <img :src="item.icon" alt="">
        </div>
      </div>
    </div>
    <bottomvan></bottomvan>
  </div>
</template>

<script>
import Topnav from '@/components/topnav.vue';
import Bottomvan from '@/components/bottomvan.vue';
import { gettxJgxxpage, gettxPolicypage, gettxNoticepage, gettxHyzxpage, gettxXhdtpage, gettxYyshpage } from "@/api/index";
export default {
  name: 'HomeView',
  components: {
    Topnav,
    Bottomvan,
  },
  data() {
    return {
      activeIndex: '',
      value: '',
      bannerlist: [
        {
          id: 1,
          img: require('@/assets/image/home/banner1.png'),
        }, {
          id: 2,
          img: require('@/assets/image/home/banner2.png'),
        }
      ],
      bottomnav1: [
        {
          id: 8,
          name: '曝光台',
          icon: require('@/assets/image/home/bottom1icon1.png'),
          path: '/about'
        },
        {
          id: 9,
          name: '接入证明查询',
          icon: require('@/assets/image/home/bottom1icon2.png'),
          path: '/about'
        },
        // {
        //   id: 3,
        //   name: '专家会审系统',
        //   icon: require('@/assets/image/home/bottom1icon3.png'),
        //   url: 'http://121.229.38.58:9004/#/home',
        //   path: 'http://121.229.38.58:9004/#/home'
        // },
        {
          id: 3,
          name: '房屋建筑通信配套设施建设管理系统',
          icon: require('@/assets/image/home/bottom1icon4.png'),
          url: 'http://121.229.38.58:9004/#/home',
          path: 'http://121.229.38.58:9004/#/home'
        }
      ],
      bottomnav2: [
        {
          id: 1,
          icon: require('@/assets/image/home/bottom2icon1.png'),
          path: 'https://www.189.cn/'
        },
        {
          id: 2,
          icon: require('@/assets/image/home/bottom2icon2.png'),
          path: 'https://www.10086.cn/'
        },
        {
          id: 3,
          icon: require('@/assets/image/home/bottom2icon3.png'),
          path: 'https://www.chinaunicom.com.cn/'
        },
        {
          id: 4,
          icon: require('@/assets/image/home/bottom2icon4.png'),
          path: 'http://www.tower.com.cn/'
        },
        {
          id: 5,
          icon: require('@/assets/image/home/bottom2icon5.png'),
          path: 'http://www.cmtietong.com/'
        },
        {
          id: 6,
          icon: require('@/assets/image/home/bottom2icon6.png'),
          path: 'https://www.chinapost.com.cn/'
        }, {
          id: 7,
          icon: require('@/assets/image/home/bottom2icon7.png'),
          path: 'https://www.sz96296.com/Pages/index.aspx'
        },
      ],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
    }
  },
  methods: {
    topage(item) {
      if (item.url) {
        window.open(item.url, '_black')
      } else {
        this.$router.push({
          path: item.path,
          query: {
            type: item.id
          }
        }, () => { }, () => { })
      }

    },
    tomore(id) {
      this.$router.push({
        path: '/about',
        query: {
          type: id
        }
      }, () => { }, () => { })
    },
    // 获取共建共享列表
    gettxPolicypagelist() {
      gettxPolicypage({ pageSize: 5, pageNum: 1 }).then(res => {
        try {
          this.list1 = res.data.list
        } catch {
          // this.$message.error('网络波动，请稍后再试')
        }
      })
    },
    // 获取竣工列表
    gettxJgxxpagelist() {
      gettxJgxxpage({ pageSize: 5, pageNum: 1 }).then(res => {
        try {
          this.list5 = res.data.list
        } catch {
          // this.$message.error('网络波动，请稍后再试')
        }
      })
    },
    // 获取行业资讯列表
    gettxHyzxpagelist() {
      gettxHyzxpage({ pageSize: 5, pageNum: 1 }).then(res => {
        try {
          this.list2 = res.data.list
        } catch {
          // this.$message.error('网络波动，请稍后再试')
        }
      })
    },
    //获取协会动态列表
    gettxXhdtpagelist() {
      gettxXhdtpage({ pageSize: 5, pageNum: 1 }).then(res => {
        try {
          this.list3 = res.data.list
        } catch {
          // this.$message.error('网络波动，请稍后再试')
        }
      })
    },
    // 获取寓意生活列表
    gettxYyshpagelist() {
      gettxYyshpage({ pageSize: 3, pageNum: 1 }).then(res => {
        try {
          this.list4 = res.data.list
        } catch {
          // this.$message.error('网络波动，请稍后再试')
        }
      })
    },
    // 获取通知公告列表
    gettxNoticepagelist() {
      gettxNoticepage({ pageSize: 3, pageNum: 1 }).then(res => {
        try {
          this.list6 = res.data.list
        } catch {
          // this.$message.error('网络波动，请稍后再试')
        }
      })
    },
    // 底部链接跳转
    toLink(url) {
      window.open(url, '_black')
    },

  },
  mounted() {
    this.gettxJgxxpagelist()
    this.gettxHyzxpagelist()
    this.gettxXhdtpagelist()
    this.gettxYyshpagelist()
    this.gettxNoticepagelist()
    this.gettxPolicypagelist()
  }
}
</script>
<style lang="scss" scoped>
.home {
  font-family: PingFang;
  .topmain {
    height: 516px;
    background: url("~@/assets/image/home/hometop.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
  }
  .top {
    height: 32px;
    padding: 0 16.6%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #6f7686;
    background: #fbfbfb;
    letter-spacing: 0.2px;
    .tianqi {
      span {
        margin-left: 8px;
      }
    }
  }
  .toptext {
    font-family: SourceHanSerifSC;
    font-weight: bold;
    font-size: 32px;
    color: #272b34;
    letter-spacing: 2px;
    text-align: left;
    margin: 36px 0;
    padding: 0 16.6%;
  }
  .banner {
    flex: 1;
    margin: 0 16.6%;
  }
  .center,
  .center2 {
    height: 370px;
    background: #f5f8fc;
    padding: 28px 16.6%;
    display: flex;
    .centeritem {
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(66, 74, 87, 0.1);
      border: radius 4px;
      flex: 1;
      overflow: hidden;
      position: relative;
      &:nth-child(2) {
        margin: 0 40px;
      }
      .itemtoptext {
        padding-left: 23px;
        position: absolute;
        top: 14px;
        div {
          font-size: 18px;
          color: #272b34;
          font-weight: 600;
          letter-spacing: 1px;
          line-height: 32px;
          text-align: left;
          &:nth-child(2) {
            font-size: 12px;
            color: #6f7686;
            line-height: 22px;
          }
        }
      }
      .textinfo {
        padding: 0 23px;
        font-size: 14px;
        color: #272b34;
        line-height: 32px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 5px;
      }
      .more {
        display: inline-block;
        width: 96px;
        height: 24px;
        background: url("~@/assets/image/home/more.png") no-repeat;
        background-size: 100% 100%;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        line-height: 24px;
        margin-top: 8px;
        cursor: pointer;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .center2 {
    background: rgba(66, 74, 87, 0.05);
    padding: 23px 16.6% 21px 16.6%;
    height: unset;
    position: relative;
    .centeritem {
      height: 196px;
      background: linear-gradient(
        226deg,
        #f3f8ff 0%,
        rgba(247, 250, 253, 0) 100%
      );
      padding: 16px 18px 0 24px;
      text-align: left;
      display: flex;
      flex-direction: column;
      .title {
        color: #272b34;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 1px;
        span {
          font-size: 14px;
          font-weight: 400;
          color: #0077ff;
          float: right;
          cursor: pointer;
        }
      }
      .center2main {
        padding-top: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        div {
          flex: 1;
          // display: flex;
          // align-items: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          z-index: 999;
        }
      }
      img {
        width: 160px;
        height: 136px;
        position: absolute;
        right: 0;
        bottom: 0;
        opacity: 0.3;
      }
    }
  }
  .moreiconlink {
    background: #f5f8fc;
    padding: 30px 16.6% 57px 16.6%;
    .bottom1 {
      display: flex;
      align-items: center;
    }
    .bottomicon {
      padding: 21px 38px 15px 15px;
      flex: 1;
      display: flex;
      background: #ffffff;
      align-items: center;
      cursor: pointer;
      img {
        width: 36px;
        height: 34px;
        margin-right: 7px;
      }
      span {
        text-align: left;
        color: #272b34;
        font-size: 18px;
        font-weight: 600;
      }
      margin-right: 40px;
      &:nth-child(4) {
        margin-right: 0;
      }
    }
    .bottom2 {
      margin-top: 20px;
      .bottomicon {
        padding: unset;
        background: unset;
        img {
          width: 100%;
          height: 100%;
        }
        margin-right: 28px;
        &:nth-child(7) {
          margin-right: 0;
        }
      }
    }
  }
}
::v-deep .el-menu {
  border: unset !important;
  font-family: SourceHanSerifSC;
  font-weight: bold;
}
::v-deep .el-menu-item {
  font-size: 16px;
  background: unset !important;
  letter-spacing: 1px;
}
::v-deep .el-submenu__title {
  background: unset !important;
  font-size: 16px;
  letter-spacing: 1px;
}
::v-deep .el-submenu__icon-arrow,
.el-icon-arrow-down {
  display: none !important;
}
</style>
